<template>
  <v-card>
    <v-card-title primary-title class="white">
      <slot name="title">
        详细信息
      </slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-form ref="form" @keyup.enter.native="validate">
      <slot :props="props" :model="model">
        <v-container grid-list-md fluid ma-0 v-if="model" full-width>
          <v-layout row wrap>
            <template v-for="item in props">
              <slot :name="'model-prop-'+item.value" :prop="item" :model="model" :readonly="readonly">
                <v-flex xs12 sm12 md6 lg4 :key="item.value">
                  <gh-input :model="model" :prop="item" :readonly="readonly"></gh-input>
                </v-flex>
              </slot>
            </template>
          </v-layout>
        </v-container>
      </slot>
    </v-form>

    <v-card-actions>
      <slot name="actions"></slot>
    </v-card-actions>

  </v-card>
</template>

<style scoped>

</style>

<script>
  import GhModelView from "./ghModelView.ts";
  export default GhModelView;
</script>